<script lang="ts" setup>
  import { UIContentWrap } from '@gohighlevel/ghl-ui'
  import Postmate from 'postmate'
  import { useAppStore } from './store/app'
  import { CommonProvider } from '@gohighlevel/ghl-proposals-common'
  import { useBuilderStore } from './store/builder'
  import { useElementOption } from './composable/elementOptions'
  import { useGroups } from './composition'
  import { useI18n } from 'vue-i18n'
  import { setSentryMeta, EmitterKeys } from '@gohighlevel/ghl-proposals-common'
  import { useEmitter } from './composable/useEmitter'
  import { setLocale as setLocalLazy } from '@gohighlevel/ghl-proposals-common/src/locales'

  const i18n = useI18n()
  const eventBus = useEmitter()

  if (process.env.NODE_ENV === 'development') {
    // Postmate.debug = true;
  }

  const appStore = useAppStore()
  const handshake = new Postmate.Model({
    'updated-token': (token: string) => appStore.refreshToken(token),
    'updated-iam-token': (token: string) => appStore.refreshIamToken(token),
    'selected-media-file': (data: any) => {
      eventBus.emit(EmitterKeys.SELECTED_MEDIA_FILE, data)
    },
  })
  window.getToken = function () {
    return appStore.tokenId
  }
  window.getAuthToken = function () {
    return appStore.iamToken
  }
  window.getPostmateHandshake = function () {
    return appStore.handshake
  }
  handshake.then(async ({ model }: any) => {
    appStore.setupApp({ ...model, handshake })
    setSentryMeta({
      userId: model.userId,
      companyId: model.companyId,
      locationId: '',
      email: model.email,
      locale: model.locale,
    })
    setLocales(model.locale || 'en-US')
  })

  const setLocales = (lang: string) => {
    let locale = lang
    locale = locale.replace('_', '-')
    localStorage.setItem('locales', locale)
    i18n.locale.value = locale
    appStore.updateLocale(locale)
    setLocalLazy(locale)
  }
</script>

<template>
  <CommonProvider
    :store-map="{ useAppStore, useBuilderStore }"
    :composition-map="{
      useElementOption,
      useGroups,
    }"
  >
    <UIContentWrap :full-screen="true">
      <router-view v-if="appStore.tokenId" />
    </UIContentWrap>
  </CommonProvider>
</template>

<style lang="scss"></style>
